<script lang="ts" setup>
import type { ImageFileField, UspSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: UspSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl">
    <h2 class="mb-xl md:mb-3xl text-center">
      {{ data.title }}
    </h2>
    <div class="gap-lg lg:gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <TeaserCard
        v-for="item in data.items" :key="item.id" :page-id="item.link.id" :image="item.optImage as ImageFileField"
        :title="item.title" :text="item.optText as string" :link-text="item.optLinkText as string" :link-url="item.link.slug"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
